import { CustomInnerHeaderProps } from 'ag-grid-react'
import { CircleQuestionMark } from 'lucide-react'

import { numberFormatter } from '@fortem-monorepo/js-utilities'
import { createColDefs } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'
import { Tooltip, TooltipContent, TooltipTrigger } from '@fortem-monorepo/react-ui'

import { ICReportTablePrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { labels } from '@/pages/funds/ic-report/constants'
import { beta } from '@/react-query/queries/ic-report/hooks'

const MyTooltipComponent = (props: CustomInnerHeaderProps) => {
  const descriptions = labels.beta.options().descriptions
  const tooltipText = descriptions[props.column.getColDef().field as keyof typeof descriptions]
  return (
    <Tooltip>
      <TooltipTrigger className={'flex items-center gap-2'}>
        <CircleQuestionMark size={14} className={'text-blue-600 shrink-0'} />
        {props.displayName}
      </TooltipTrigger>
      <TooltipContent align={'start'}>{tooltipText}</TooltipContent>
    </Tooltip>
  )
}

const percentageFormatter = numberFormatter({
  suffix: '%',
  transformer: (val) => val * 100,
})

const colDefs = createColDefs([
  {
    field: 'option_type',
    headerName: 'Option',
  },
  {
    field: 'bbg_ticker',
    headerName: 'Ticker',
  },
  {
    field: 'strike',
  },
  {
    field: 'maturity_date',
    headerName: 'Maturity',
  },
  {
    field: 'position_delta_risk_weight',
    headerName: 'Position Delta Risk Weight',
    valueFormatter: percentageFormatter,
    tooltipField: 'position_delta_risk_weight',
    headerComponentParams: {
      innerHeaderComponent: MyTooltipComponent,
    },
  },
  {
    field: 'moneyness_distance',
    headerName: 'Moneyness Distance',
    valueFormatter: percentageFormatter,
    headerComponentParams: {
      innerHeaderComponent: MyTooltipComponent,
    },
  },
  {
    field: 'moneyness_label',
    headerName: 'Moneyness Label',
  },
  {
    field: 'position_value_base_over_nav',
    headerName: 'Position Value as % of NAV',
    valueFormatter: percentageFormatter,
    headerComponentParams: {
      innerHeaderComponent: MyTooltipComponent,
    },
  },
  {
    field: 'index',
    hide: true,
  },
])

export interface BetaOptionsTableProps extends ICReportTablePrimitive {}

export const BetaOptionsTable: React.FC<BetaOptionsTableProps> = ({ params, options }) => {
  const query = beta.useOptions(params)
  const data = query.data

  return <CustomAgGrid loading={query.isLoading} rowData={data} columnDefs={colDefs} {...options} />
}
